import React from 'react';
import { Modal, Button } from 'react-bootstrap'; // Assuming you're using React Bootstrap for modals

const ViewEOIModal = ({ show, handleClose, eoi }) => {
    if (!eoi) return null;

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>View EOI Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="mb-3">
                    <strong>ID:</strong> {eoi.id}
                </div>
                <div className="mb-3">
                    <strong>Client Name:</strong> {eoi.clientName}
                </div>
                <div className="mb-3">
                    <strong>Client Number:</strong> {eoi.clientNumber}
                </div>
                <div className="mb-3">
                    <strong>Broker Name:</strong> {eoi.broker.name}
                </div>
                <div className="mb-3">
                    <strong>Developer Sales:</strong> {eoi.developer_sales.name}
                </div>
                <div className="mb-3">
                    <strong>Project:</strong> {eoi.project.name}
                </div>
                <div className="mb-3">
                    <strong>Status:</strong> {eoi.status}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ViewEOIModal;
